import { OrdersState } from "../types";

export const depositeState: Partial<OrdersState> = {
  paymentProviders: [],
  activeProvider: null,
  allowDepositeActions: true,
}